import React, { CSSProperties } from 'react';
import Page from '../../components/UI/layout/Page';
import { useProjectConfigContext } from '../../contexts/ProjectConfigContext';
import DesplaySmallMessage from './DesplaySmallMessage';

const titleStyle: CSSProperties = {
    fontSize: "3rem",
}

const ErrorStyle: CSSProperties = {
    fontSize: "5rem",
}

const containerStyle: CSSProperties = {
    paddingTop: "5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
}

const NotFoundPage = () => {

    const { projectConfigMessage } = useProjectConfigContext();
    const title = 'דף לא קיים';

    return (
        <Page>
            <div style={containerStyle}>
                
                <div style={titleStyle}>{title}</div>
                
                <div style={ErrorStyle}>404</div>
                
                <DesplaySmallMessage message={projectConfigMessage} />
            </div>
        </Page>
    );
}

export default NotFoundPage;